import request from "@/utils/request";
export default {
  // 分页查询
  getTableLists: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/list`,
      method: "post",
      data: param,
    });
  },
  // 查询ASL Group
  getAslGroupList: (sponsor) => {
    return request({
      url: `/rmc/protein/asl/aslGroupList?sponsor=${sponsor}`,
      method: "post",
      data: {},
    });
  },
  // 获取sponsor
  getSponsorByUser: () => {
    return request({
      url: `/rmc/protein/medicine/getSponsorByUser`,
      method: "post",
      data: {},
    });
  },
  // 下拉框列表
  getSelection: (param) => {
    return request({
      url: `/downloadList`,
      method: "post",
      data: param,
    });
  },
  // 饲料厂明细
  getDetailInfo: (rmcProteinFeedFactoryId) => {
    return request({
      url: `/rmc/protein/feedFactory/detail/${rmcProteinFeedFactoryId}`,
      method: "post",
      data: {},
    });
  },
  // 获取授权的Category3
  getAuthorizedCategory3: () => {
    return request({
      url: `/rmc/protein/farm/authorizedCategory3`,
      method: "get",
    });
  },
  // 新增
  addReq: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/create`,
      method: "post",
      data: param,
    });
  },
  // 更新
  updateReq: (rmcProteinFeedFactoryId, param) => {
    return request({
      url: `/rmc/protein/feedFactory/update/${rmcProteinFeedFactoryId}`,
      method: "post",
      data: param,
    });
  },
  // 提交
  submitReq: (rmcProteinFeedFactoryId, param) => {
    return request({
      url: `/rmc/protein/feedFactory/submit/${rmcProteinFeedFactoryId}`,
      method: "post",
      data: param,
    });
  },
  // 批量提交
  submitBtach: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/submit`,
      method: "post",
      data: param,
    });
  },
  // 1/2方验证审核维护(10=1方，20=2方)
  partyAuditUpdate: (param, party) => {
    return request({
      url: `/rmc/protein/feedFactory/partyAuditUpdate/${party}`,
      method: "post",
      data: param,
    });
  },
  // 文件描述提交
  updateDocComments: (param) => {
    return request({
      url: `/file/updateDocComments`,
      method: "post",
      data: param,
    });
  },
  // 批量批准
  approveReq: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/approve`,
      method: "post",
      data: param,
    });
  },
  // 批量退回
  returnReq: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/return`,
      method: "post",
      data: param,
    });
  },
  // 确认无更新
  confirmNoChange: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/confirmNoChange`,
      method: "post",
      data: param,
    });
  },
  // 批量删除
  deleteReq: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/delete`,
      method: "post",
      data: param,
    });
  },
  // 更新日志列表
  updateLog: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/updateLog`,
      method: "post",
      data: param,
    });
  },
  // 导出更新日志
  downloadUpdateLogList: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/downloadUpdateLogList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 导出
  downloadLists: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/downloadFeedFactoryList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 1/2方验证审核报告列表[[party=10(1方)，party=20(2方)]]
  getPartyAuditReportList: (party, id) => {
    return request({
      url: `/rmc/protein/feedFactory/partyAuditReportList/${party}/${id}`,
      method: "get",
    });
  },
  // 批量上传1/2方验证审核报告
  uploadPartyAuditReport: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/uploadPartyAuditReport`,
      method: "post",
      data: param,
    });
  },
  // 审核报告下载
  downloadPartyAuditReport: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/downloadPartyAuditReport`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 导出季度审核员清单
  downloadFeedFactoryQuarterList: (param) => {
    return request({
      url: `/rmc/protein/feedFactory/downloadFeedFactoryQuarterList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 季度导出
  exportMedicineUsageSnapshot: (param) => {
    return request({
      url: `/rmc/protein/medicineUsage/exportMedicineUsageSnapshot`,
      method: 'post',
      data: param,
      responseType: "blob",
      fullResponse: true,
    });
  },
};
